import React from 'react';

import styled from '@emotion/styled';

import LargeCheckMarkIcon from '../../../components/Icons/LargeCheckMarkIcon';

const RatingSuccess = () => {
  return (
    <Container>
      <ContentArea>
        <SuccessView>
          <IconArea>
            <LargeCheckMarkIcon />
          </IconArea>
          <Success>Thank You for Your Feedback!</Success>
          <SuccessDescription>
            Your rating has been received successfully and helps us serve you
            better.
          </SuccessDescription>
        </SuccessView>
      </ContentArea>
    </Container>
  );
};

export default RatingSuccess;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: white;
`;

const ContentArea = styled.div`
  width: 555px;
  margin-top: 64px;
  background-color: ${({ theme }) => theme.palette.pageBgColor};
  max-width: 400px;

  @media (max-width: 884px) {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const SuccessView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
  min-height: 289px;
  padding: 40px 18px;
  background-color: ${({ theme }) => theme.palette.pageBgColor};
`;

const Success = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.logirateBlack};
  text-align: center;
`;

const IconArea = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 16px;
  background: rgba(91, 145, 245, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor};
  }

  &.pink {
    background-color: ${({ theme }) => theme.palette.logiratePrimaryLight};
  }

  &.pink > svg {
    color: ${({ theme }) => theme.palette.logiratePrimary};
  }
`;

const SuccessDescription = styled.div`
  font-size: 14px;
  line-height: 25px;
  font-weight: 400;
  text-align: center;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
